import React from 'react';
import './homePaciente.scss';

export default function HomePaciente () {
    return (
        <>
            <div className='home-paciente-container'>
                <div className='home-paciente-banner'>   
                    <div className='home-paciente-sistema'>
                        <div className='home-paciente-sistema-titulo'>
                            Bienvenido a casa, bienvenido a Nutrihome.<br />
                            <span className='home-paciente-sistema-texto'>Nutrición clínica domiciliaria y cuidados paliativos domiciliarios.</span>
                        </div>
                    </div>
                </div>

                <div className='home-paciente-accion'>
                    <div className='home-paciente-accion-titulo'>
                        Acción Integral y Centrada en el Paciente
                    </div>                    
                    <div className='home-paciente-accion-texto'>
                        Cuando un paciente requiere soporte nutricional oral, enteral o parenteral de forma transitoria o definitiva y no existen otros motivos para que permanezca hospitalizado, este tratamiento debe realizarse en su domicilio. En Nutrihome, nos especializamos en Soporte Nutricional y Cuidados Paliativos Domiciliarios, cubriendo todos los aspectos de la práctica a través de nuestros equipos de profesionales especializados.
                    </div>                    
                </div>    

                <div className='home-paciente-grilla'>
                    <div className='home-paciente-column home-paciente-azul'>
                        <div className='home-paciente-bloque'>
                            <div className='home-paciente-titulo'>
                                Objetivos asistenciales<br /> de Nutrihome
                            </div>
                            <div className='home-paciente-grilla-interna'>
                                <div className='home-paciente-grilla-interna-column'>
                                    Facilitar y acompañar en la transición del paciente del hospital al domicilio.
                                </div>
                                <div className='home-paciente-grilla-interna-column'>
                                    Prevenir complicaciones y garantizar así una mayor seguridad del tratamiento.
                                </div>
                                <div className='home-paciente-grilla-interna-column'>
                                    Mejoramos la calidad de vida de los pacientes que requieren cuidados paliativos en su propio domicilio.
                                </div>
                                <div className='home-paciente-grilla-interna-column'>
                                    Consolidar la autonomía del paciente en la gestión de su tratamiento.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='home-paciente-column home-paciente-medicos'>
                        <div className='home-paciente-bloque'>
                            <div className='home-paciente-titulo'>
                                Conocé nuestros<br />servicios, visítanos
                            </div>
                            <div className='home-paciente-texto'>
                                <a href="https://www.carehome.com.ar" style={{ color: 'white', textDecoration: 'underline'}} target='_blank' title='Ir a la página de Carehome'>www.carehome.com.ar</a>
                            </div>
                            <div className='home-paciente-texto'>
                                <a href="https://www.nutrihome.com.ar" style={{ color: 'white', textDecoration: 'underline'}} target='_blank' title='Ir a la página de Nutrihome'>www.nutrihome.com.ar</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
        </>
    )
};